var map = {
	"./NEAR.svg": "2afb",
	"./activity.svg": "8dd6",
	"./add.svg": "76a4",
	"./archive.svg": "8238",
	"./arrow-down.svg": "c874",
	"./back arrow.svg": "7bbe",
	"./back-arrow.svg": "85f2",
	"./back.svg": "7338",
	"./backward.svg": "1412",
	"./boilerplate-commission.svg": "65b5",
	"./browse files.svg": "ef44",
	"./calendar.svg": "b8bd",
	"./campaign.svg": "8872",
	"./check-icon.svg": "fdfe",
	"./check.svg": "7bae",
	"./clock-icon.svg": "e315",
	"./close-drawer.svg": "6e9b",
	"./close.svg": "8b1b",
	"./coinbasewallet.svg": "cd36",
	"./collection.svg": "3539",
	"./commission.svg": "ee4b",
	"./copy.svg": "8aac",
	"./default.svg": "b5c3",
	"./discord.svg": "e3a3",
	"./dollar.svg": "ae9c",
	"./down.svg": "d8aa",
	"./edit.svg": "daf0",
	"./email.svg": "43be",
	"./embargo time.svg": "6f61",
	"./ethereum.svg": "0c5f",
	"./factory.svg": "cc7a",
	"./fortmatic.svg": "d5f9",
	"./forward.svg": "bdb1",
	"./history.svg": "14e1",
	"./info.svg": "76ed",
	"./location.svg": "d2eb",
	"./lock-icon.svg": "47d9",
	"./lock.svg": "9619",
	"./logout-inverted.svg": "e464",
	"./logout.svg": "69e3",
	"./medium.svg": "4f40",
	"./menu.svg": "d17f",
	"./metamask.svg": "a9b9",
	"./moonpay.svg": "4ce6",
	"./percent.svg": "58c8",
	"./portis.svg": "977c",
	"./profile.svg": "95dc",
	"./qr code.svg": "feeb",
	"./receive-icon.svg": "b483",
	"./recenter.svg": "2226",
	"./rejected.svg": "475f",
	"./save.svg": "9344",
	"./search.svg": "d103",
	"./send-icon.svg": "66db",
	"./settings.svg": "9174",
	"./stopwatch.svg": "aac5",
	"./template-art.svg": "f505",
	"./template-music.svg": "bb33",
	"./template-trading-cards.svg": "5715",
	"./torus.svg": "2a0f",
	"./transaction rejected.svg": "47bb",
	"./transaction sent.svg": "ccfd",
	"./transaction succeeded.svg": "8576",
	"./unlock.svg": "d901",
	"./up.svg": "5c5b",
	"./verify.svg": "945e",
	"./view.svg": "00ed",
	"./wallet.svg": "4f4a",
	"./walletconnect.svg": "c57c",
	"./webgl-indicator.svg": "d424"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";